import { Button, styled } from '@mui/material';
import { Content } from 'components/Modal';
import NotificationCoin from 'assets/icons/NotificationCoin';

export const StyledContent = styled(Content)`
  padding-top: 2rem;
  text-align: center;
`;

export const Image = styled(NotificationCoin)`
  height: auto;
  margin: 1rem auto;
  width: 50%;
`;

export const StyledButton = styled(Button)`
  margin-top: 1rem;
`;
